const STORAGE_KEY = 'lpr:lastLearnerId';

export function getLastLearnerId(): string | null {
  try {
    return sessionStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

export function setLastLearnerId(learnerId: string): void {
  if (!learnerId) return;
  try {
    sessionStorage.setItem(STORAGE_KEY, learnerId);
  } catch {
    /* private browsing or storage full */
  }
}

export function dashboardPath(learnerId?: string | null): string {
  const id = learnerId ?? getLastLearnerId();
  return id ? `/dashboard?child=${encodeURIComponent(id)}` : '/dashboard';
}

export function childProfilePath(learnerId: string, tab?: string): string {
  const base = `/children/${encodeURIComponent(learnerId)}`;
  return tab ? `${base}?tab=${encodeURIComponent(tab)}` : base;
}

export function pathForApplication(
  learners: Array<{ learnerId: string; applicationId: string }>,
  applicationId: string,
  preferProfile = true,
): string {
  const learner = learners.find((item) => item.applicationId === applicationId);
  if (learner) {
    setLastLearnerId(learner.learnerId);
    return preferProfile ? childProfilePath(learner.learnerId) : dashboardPath(learner.learnerId);
  }
  return dashboardPath();
}
